import { render, staticRenderFns } from "./trial-duration-explanation.vue?vue&type=template&id=443ea964&scoped=true&"
import script from "./trial-duration-explanation.vue?vue&type=script&lang=js&"
export * from "./trial-duration-explanation.vue?vue&type=script&lang=js&"
import style0 from "./trial-duration-explanation.vue?vue&type=style&index=0&id=443ea964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443ea964",
  null
  
)

export default component.exports